import Map from '../../Map';

/**
 * Created by mestrad on 2018. 09. 25..
 */

export default Corporate;

import Base from "./Base";
import AutoComplete from "../../AutoComplete";
const $ = jQuery;

function Corporate( config ) {
    Base.call(this, config);
    var self = this;
    var searchMap;
    var placeholderList;
    var filterCount = 0;
    var categoryList;
    var nameSpaceConnectionTypeList = ["parent"];
    var geoConnectionTypeList = ["parent"];

    function render( placeholders ) {
        placeholderList = placeholders;
        addSearchMap();
        initEvents();
    }

    function createFilter( type = false, defaultSelected = false, relation = 'and' ) {
        if ( !! $( config.domElements.wrapperSelector ).children().length ) {
            var newFilterId = `#${ self.getSelectId( filterCount, 'Types' ) }`;
            self.addFilter(config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes( categoryList, getExtraFilterTypes() ),
                newFilterId
            );
            var activeOption = self.getFilterTypes( categoryList, getExtraFilterTypes())[0].id;
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper( newWrapper, activeOption );
            initFilterEvents( type, defaultSelected, relation );
            return;
        }
        filterCount = 0;

        var formCode = '<div id="nnpSearchSelectContainer">';
        self.getOptionList('category-types', function( categories ){
            categoryList = categories;
            var filterTypes = self.getFilterTypes( categories, getExtraFilterTypes() );
            formCode += self.createSelect( filterTypes, config.domElements.filterTypesId, config.domElements.filterTypesClass ) + '<div class="filterSelectWrapper">';
            placeholderList.$wrapperObj.html(formCode);

            var holderInput = self.createAutoCompleteInput( config.domElements.filterOptionsId + "helper" );
            formCode += holderInput;
            formCode += self.createRelationSelect( filterCount ) + '</div>';
            formCode += self.createAddAndRemoveBtn() + '</div>';
            placeholderList.$wrapperObj.html(formCode);
            AutoComplete({
                holderItem: "#" + config.domElements.filterOptionsId + "helper",
                ajaxUrl: config.ajaxUrl,
                objectType: geoConnectionTypeList.indexOf(filterTypes[0].id) > -1 ? "geo" : "corporate",
                locale: config.locale,
                type: nameSpaceConnectionTypeList.indexOf(filterTypes[0].id) > -1 ? "search" : "category-types",
                categoryType: filterTypes[0].id
            });
            initFilterEvents( type, defaultSelected, relation );
        });
    }

    function getExtraFilterTypes()
    {
        var extraFilters = [];
        /*
        extraFilters.push({
            "title": "Felettes",
            "id": "parent"
        });
        */
        return extraFilters;
    }

    function addSearchMap() {
        if ( searchMap == undefined ) {
            searchMap = new Map( {
                elementId:   placeholderList.$searchMap[ 0 ].id,
                domElements: config.domElements,
                type:        'search'
            } );
            searchMap.refresh();
        }
    }

    function initEvents() {
        config.$baseForm.on( 'searchResultReceived', function ( event, receivedData ) {
            searchMap.refresh( receivedData );
        } );
    }

    function initFilterEvents( type = false, defaultSelected = false, relation = 'and' ) {
        var addBtn = $(".addFilterBtn");
        var removeBtn = $(".removeFilterBtn");
        var filterTypeSelect = $("#" + self.getSelectId( filterCount, "Types" ));
        addBtn.off("click");
        removeBtn.off("click");
        addBtn.on("click", function(){
            var activeOption = self.getFilterTypes( categoryList, getExtraFilterTypes())[0].id;
            var newFilterId = "#" + self.getSelectId( filterCount, "Types" );
            self.addFilter( config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes( categoryList, getExtraFilterTypes()),
                newFilterId );
            initFilterEvents();
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper( newWrapper, activeOption );
        });
        removeBtn.on("click", function(){
            self.removeFilter( this );
            self.refreshSearchWrapper( self.getFilterTypes( categoryList, getExtraFilterTypes()) );
        });
        filterTypeSelect.on("change", function(){
            refreshAllSelectOptions( filterTypeSelect.val(), "#" + filterTypeSelect.attr("id"), filterTypeSelect.parent() );
        });
        if ( type ) {
            var newFilterId = `#${ self.getSelectId( filterCount, 'Types' ) }`;
            $( newFilterId )
            .find( `option[value="${ type }"]` )
            .prop( 'selected', true )
            .parent()
            .trigger( 'change' );
            var newWrapper = $( newFilterId ).parent().find( '.filterSelectWrapper' );
            var $select    = $( newWrapper )
            .find( `#nnpSearchFilterInput${ filterCount
                                                               ? `_${ filterCount }`
                                                               : '' }helper` );

            if ( defaultSelected ) {
                defaultSelected.forEach( function ( e ) {
                    if ( $select.find( `option[value="${ e.id }"]` ).length ) {
                        $select.val( e.id ).trigger( 'change' );
                    } else {
                        $select.append( new Option( e.text, e.id, true, true ) )
                               .trigger( 'change' );
                    }
                } );
            }
            var $relation = $( newWrapper )
            .find( `#${ config.domElements.filterRelationId }${ filterCount
                                                                ? `_${ filterCount }`
                                                                : '' }` );
            $relation.prop( 'selectedIndex', $relation.find( `[value=${ relation }]` ).index() );
        }
        filterCount++;
    }

    function refreshAllSelectOptions( value, selectId, parent )
    {
        refreshFilterWrapper( parent.find(".filterSelectWrapper"), value );
        self.refreshSearchWrapper( self.getFilterTypes( categoryList, getExtraFilterTypes()), selectId );
    }

    function refreshFilterWrapper( wrapper, value )
    {
        // if( $.inArray( value, notAutoCompleteTypeList ) < 0 ){
        //     appendFilterSelect( wrapper, value );
        // } else {
            appendFilterInput( wrapper, value );
        // }
    }

    function appendFilterSelect( wrapper, value )
    {
        var filterTypes = self.getFilterTypes( categoryList, getExtraFilterTypes());
        filterTypes.forEach(function(item){
            if(item.id == value){
                var selectId = wrapper.children().attr("id") || self.getSelectId( filterCount-1, "Options" );
                wrapper.children().remove();
                wrapper.append(self.createSelect( self.getCategoryItems( value, categoryList ), selectId, config.domElements.filterOptionsClass ) +
                    self.createRelationSelect( filterCount-1 ));
            }
        });
    }

    function appendFilterInput( wrapper, value )
    {
        var helperArray = wrapper.prev().attr("id").split('_');
        var filterIndex = helperArray.length === 1 ? 0 : helperArray[helperArray.length -1];
        var filterTypes = self.getFilterTypes( categoryList, getExtraFilterTypes());
        filterTypes.forEach(function(item){
            if(item.id === value){
                var selectId = self.getSelectId( filterIndex, "Input" );
                var holderInput = self.createAutoCompleteInput( selectId + "helper" );
                wrapper.children().remove();
                wrapper.append( holderInput +
                self.createRelationSelect( filterIndex ));
                AutoComplete({
                    holderItem: "#" + selectId + "helper",
                    ajaxUrl: config.ajaxUrl,
                    objectType: geoConnectionTypeList.indexOf(item.id) > -1 ? "geo" : "corporate",
                    locale: config.locale,
                    type: nameSpaceConnectionTypeList.indexOf(item.id) > -1 ? "search" : "category-types",
                    categoryType: item.id,
                });
            }
        });
    }

    return {
        render: render,
        createFilter: createFilter
    };
}

Corporate.prototype = Object.create(Base.prototype);